import { render } from "./customerStageList.vue?vue&type=template&id=2707bad9&scoped=true"
import script from "./customerStageList.vue?vue&type=script&lang=js"
export * from "./customerStageList.vue?vue&type=script&lang=js"

import "./customerStageList.vue?vue&type=style&index=0&id=2707bad9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2707bad9"]])

export default __exports__